module.exports = __webpack_public_path__ + "img/重庆大学.2569cfc7.png";